import React from "react"

import { Content } from "../styles"

const Text = ({ element, ...props }) => {
  const { text, end = false } = element
  return (
    <Content
      dangerouslySetInnerHTML={{
        __html: text,
      }}
      end={end.toString()}
      {...props}
    />
  )
}

export default Text
